import { SharedModule } from 'src/app/shared/shared.module'

import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromInternalEvent from '../internal-event/internal-event.reducer'
import { InternalEventRoutingModule } from './internal-event-routing.module'
import { InternalEventEffects } from './internal-event.effects'
import { InternalEventSerializer } from './internal-event.serializer'
import { InternalEventService } from './internal-event.service'

@NgModule({
    imports: [
        InternalEventRoutingModule,
        SharedModule,
        StoreModule.forFeature(fromInternalEvent.FEATURE_NAME, fromInternalEvent.internalEventReducer),
        EffectsModule.forFeature([InternalEventEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        InternalEventService,
        {
            provide: InternalEventSerializer,
            useClass: InternalEventSerializer
        }
    ]
})
export class InternalEventModule {}
